import Immutable from 'immutable';

import {
  GET_LOCATION_BOOTUPS_FAILURE,
  GET_LOCATION_BOOTUPS_REQUEST,
  GET_LOCATION_BOOTUPS_SUCCESS,
  GET_LOCATION_OCCUPANCIES_FAILURE,
  GET_LOCATION_OCCUPANCIES_REQUEST,
  GET_LOCATION_OCCUPANCIES_SUCCESS,
  GET_LOCATION_STATUS_REQUEST,
  GET_LOCATION_STATUS_SUCCESS,
  GET_LOCATION_UNLOCKS_FAILURE,
  GET_LOCATION_UNLOCKS_REQUEST,
  GET_LOCATION_UNLOCKS_SUCCESS,
} from './monitoring.actions';

const initialState = Immutable.Map({
  isLoading: false,
  isLoadingConnectionStat: false,
  isLoadingOccupancies: false,
  isLoadingUnlocks: false,
  isLoadingBootups: false,
  errors: [],
  
  selectedLocationConnectionStat: {},
  selectedLocationStatus: {},
  selectedLocationOccupancies: [],
  selectedLocationUnlocks: [],
  selectedLocationBootups: [],
  locationsWithAlerts: [],
  locations: [],
});

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_LOCATION_STATUS_SUCCESS:
      return state
        .set('selectedLocationStatus', action.response)
        .set('isLoading', false);
  
    case GET_LOCATION_STATUS_REQUEST:
      return state.set('isLoading', true);

    case GET_LOCATION_OCCUPANCIES_FAILURE:
      return state.set('errors', action.messages).set('isLoadingOccupancies', false);

    case GET_LOCATION_OCCUPANCIES_SUCCESS:
      return state
        .set('selectedLocationOccupancies', action.response)
        .set('isLoadingOccupancies', false);
  
    case GET_LOCATION_OCCUPANCIES_REQUEST:
      return state.set('isLoadingOccupancies', true);

    case GET_LOCATION_UNLOCKS_FAILURE:
      return state.set('errors', action.messages).set('isLoadingUnlocks', false);

    case GET_LOCATION_UNLOCKS_SUCCESS:
      return state
        .set('selectedLocationUnlocks', action.response)
        .set('isLoadingUnlocks', false);

    case GET_LOCATION_UNLOCKS_REQUEST:
      return state.set('isLoadingUnlocks', true);

    case GET_LOCATION_BOOTUPS_FAILURE:
      return state.set('errors', action.messages).set('isLoadingBootups', false);

    case GET_LOCATION_BOOTUPS_SUCCESS:
      return state
        .set('selectedLocationBootups', action.response)
        .set('isLoadingBootups', false);
  
    case GET_LOCATION_BOOTUPS_REQUEST:
      return state.set('isLoadingBootups', true);

    default:
      return state;
  }
}